export const buildSessionExpiredLoginUrl = (nextPath?: string) => {
  const redirectParams = new URLSearchParams();
  redirectParams.set('reason', 'session-expired');
  const normalizedNext = (nextPath || `${window.location.pathname}${window.location.search}`).trim();
  if (normalizedNext && normalizedNext !== '/login') {
    redirectParams.set('next', normalizedNext);
  }
  return `/login?${redirectParams.toString()}`;
};

export const redirectToSessionExpiredLogin = (nextPath?: string) => {
  window.location.href = buildSessionExpiredLoginUrl(nextPath);
};
